import React from 'react';
import { X } from 'lucide-react';
import { SlideshowSettings } from '../types';

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  settings: SlideshowSettings;
  onSettingsChange: (settings: SlideshowSettings) => void;
}

const SettingsModal: React.FC<SettingsModalProps> = ({
  isOpen,
  onClose,
  settings,
  onSettingsChange
}) => {
  if (!isOpen) return null;

  const handleImageDurationChange = (value: number) => {
    onSettingsChange({
      ...settings,
      imageDuration: value
    });
  };

  const handleTransitionStyleChange = (style: SlideshowSettings['transitionStyle']) => {
    onSettingsChange({
      ...settings,
      transitionStyle: style
    });
  };

  const handleQRCodeToggle = () => {
    onSettingsChange({
      ...settings,
      showQRCode: !settings.showQRCode
    });
  };

  const handleHideHeaderToggle = () => {
    onSettingsChange({
      ...settings,
      hideHeader: !settings.hideHeader
    });
  };

  const handleShowQRCodeInFullscreenToggle = () => {
    onSettingsChange({
      ...settings,
      showQRCodeInFullscreen: !settings.showQRCodeInFullscreen
    });
  };

  const handleResetToDefault = () => {
    const defaultSettings: SlideshowSettings = {
      imageDuration: 3,
      transitionStyle: 'fade',
      showQRCode: true,
      hideHeader: false,
      showQRCodeInFullscreen: true
    };
    onSettingsChange(defaultSettings);
  };


  return (
    <div className="settings-modal-overlay" onClick={onClose}>
      <div className="settings-modal" onClick={(e) => e.stopPropagation()}>
        <div className="settings-header">
          <h3>Settings</h3>
          <button className="close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        
        <div className="settings-content">
          <div className="setting-group">
            <label htmlFor="imageDuration">Image Duration (seconds)</label>
            <input
              id="imageDuration"
              type="range"
              min="1"
              max="10"
              step="0.5"
              value={settings.imageDuration}
              onChange={(e) => handleImageDurationChange(parseFloat(e.target.value))}
            />
            <span className="setting-value">{settings.imageDuration}s</span>
          </div>
          
          <div className="setting-group">
            <label htmlFor="transitionStyle">Transition Style</label>
            <select
              id="transitionStyle"
              value={settings.transitionStyle}
              onChange={(e) => handleTransitionStyleChange(e.target.value as SlideshowSettings['transitionStyle'])}
            >
              <option value="fade">Fade</option>
              <option value="dissolve">Dissolve</option>
              <option value="ease-in">Ease In</option>
              <option value="slide">Slide</option>
            </select>
          </div>
          
          <div className="setting-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={settings.showQRCode}
                onChange={handleQRCodeToggle}
              />
              Show QR Code
            </label>
          </div>
          
          <div className="setting-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={settings.hideHeader}
                onChange={handleHideHeaderToggle}
              />
              Hide Header
            </label>
          </div>
          
          <div className="setting-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={settings.showQRCodeInFullscreen}
                onChange={handleShowQRCodeInFullscreenToggle}
              />
              Show QR Code in Fullscreen
            </label>
          </div>
          
          <div className="setting-group reset-section">
            <button 
              className="reset-default-btn"
              onClick={handleResetToDefault}
            >
              Reset to Default
            </button>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;
